/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 27tSQAx4CoUX

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import InfoSection from "../../InfoSection"; // plasmic-import: 0gf8lKLu2jNB/component
import { RawUl } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawList/Ul"; // plasmic-import: MgrwvgDVmmr8/codeComponent
import { RawLi } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawList/Li"; // plasmic-import: AzSSlTj_Nw6K/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicSecurityPracticesBanner.module.css"; // plasmic-import: 27tSQAx4CoUX/css

createPlasmicElementProxy;

export type PlasmicSecurityPracticesBanner__VariantMembers = {};
export type PlasmicSecurityPracticesBanner__VariantsArgs = {};
type VariantPropType = keyof PlasmicSecurityPracticesBanner__VariantsArgs;
export const PlasmicSecurityPracticesBanner__VariantProps =
  new Array<VariantPropType>();

export type PlasmicSecurityPracticesBanner__ArgsType = {};
type ArgPropType = keyof PlasmicSecurityPracticesBanner__ArgsType;
export const PlasmicSecurityPracticesBanner__ArgProps =
  new Array<ArgPropType>();

export type PlasmicSecurityPracticesBanner__OverridesType = {
  banner?: Flex__<"div">;
  container?: Flex__<"section">;
  wrapper?: Flex__<"div">;
  heading?: Flex__<"div">;
  title?: Flex__<"h1">;
  contentRow?: Flex__<"div">;
  contentColumn?: Flex__<"div">;
  exploreOurSecurityPractices?: Flex__<typeof InfoSection>;
  comprehensiveDataProtection?: Flex__<typeof InfoSection>;
  h3?: Flex__<"h3">;
  proactiveRiskManagement?: Flex__<typeof InfoSection>;
  regulatoryCompliance?: Flex__<typeof InfoSection>;
  clientCentricSecurityFeatures?: Flex__<typeof InfoSection>;
  trainingAndAwareness?: Flex__<typeof InfoSection>;
  commitmentToContinuousImprovement?: Flex__<typeof InfoSection>;
  questions?: Flex__<typeof InfoSection>;
  link?: Flex__<"a"> & Partial<LinkProps>;
  line?: Flex__<typeof PlasmicImg__>;
};

export interface DefaultSecurityPracticesBannerProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSecurityPracticesBanner__RenderFunc(props: {
  variants: PlasmicSecurityPracticesBanner__VariantsArgs;
  args: PlasmicSecurityPracticesBanner__ArgsType;
  overrides: PlasmicSecurityPracticesBanner__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"banner"}
      data-plasmic-override={overrides.banner}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.banner
      )}
    >
      <section
        data-plasmic-name={"container"}
        data-plasmic-override={overrides.container}
        className={classNames("all", sty.container)}
      >
        <div
          data-plasmic-name={"wrapper"}
          data-plasmic-override={overrides.wrapper}
          className={classNames("all", sty.wrapper)}
        >
          <div
            data-plasmic-name={"heading"}
            data-plasmic-override={overrides.heading}
            className={classNames("all", sty.heading)}
          >
            <h1
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                "all",
                "h1",
                "h1__bvRZj",
                "__wab_text",
                sty.title
              )}
            >
              {"Security Practices"}
            </h1>
          </div>
          <div
            data-plasmic-name={"contentRow"}
            data-plasmic-override={overrides.contentRow}
            className={classNames("all", sty.contentRow)}
          >
            <div
              data-plasmic-name={"contentColumn"}
              data-plasmic-override={overrides.contentColumn}
              className={classNames("all", sty.contentColumn)}
            >
              <InfoSection
                data-plasmic-name={"exploreOurSecurityPractices"}
                data-plasmic-override={overrides.exploreOurSecurityPractices}
                className={classNames(
                  "__wab_instance",
                  sty.exploreOurSecurityPractices
                )}
                content={
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.p__gVi2
                    )}
                  >
                    {
                      "At MyEvaluations, we believe that strong security practices are the foundation of trust. Here's an overview of the measures we take to protect your data and ensure compliance with the highest industry standards."
                    }
                  </p>
                }
                heading={"Explore Our Security Practices"}
              />

              <InfoSection
                data-plasmic-name={"comprehensiveDataProtection"}
                data-plasmic-override={overrides.comprehensiveDataProtection}
                className={classNames(
                  "__wab_instance",
                  sty.comprehensiveDataProtection
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__z9C9Z
                      )}
                    >
                      {
                        "We implement advanced security protocols to safeguard all data stored in and transmitted through our platform:"
                      }
                    </p>
                    <h3
                      data-plasmic-name={"h3"}
                      data-plasmic-override={overrides.h3}
                      className={classNames(
                        "all",
                        "h3",
                        "h3__bvRZj",
                        "__wab_text",
                        sty.h3
                      )}
                    >
                      {"Why SOC 2 Type II Matters:"}
                    </h3>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__mqqw)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__eMg9M
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__bXqRl
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"End-to-End Encryption:"}
                            </span>
                            <React.Fragment>
                              {
                                " All sensitive information is encrypted in transit (using TLS 1.2+) and at rest (AES-256 encryption)."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__j8Vlo
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__j1Hf7
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Secure Authentication:"}
                            </span>
                            <React.Fragment>
                              {
                                " Role-based access controls and multi-factor authentication (MFA) ensure that only authorized personnel can access sensitive information."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__ow6Gd
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__xv3X7
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Data Backup and Recovery:"}
                            </span>
                            <React.Fragment>
                              {
                                " Regular backups and disaster recovery plans guarantee that your data is always accessible and secure."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Comprehensive Data Protection"}
              />

              <InfoSection
                data-plasmic-name={"proactiveRiskManagement"}
                data-plasmic-override={overrides.proactiveRiskManagement}
                className={classNames(
                  "__wab_instance",
                  sty.proactiveRiskManagement
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__uuSZn
                      )}
                    >
                      {
                        "Our systems are designed to anticipate and mitigate risks:"
                      }
                    </p>
                    <RawUl
                      className={classNames(
                        "__wab_instance",
                        sty.rawUl___40D6N
                      )}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__lHHbQ
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__lIi1U
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Continuous Monitoring:"}
                            </span>
                            <React.Fragment>
                              {
                                " We use advanced monitoring tools to detect and respond to potential threats in real time."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__gFnwO
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__gwY6G
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Routine Penetration Testing:"}
                            </span>
                            <React.Fragment>
                              {
                                " Regular testing by independent experts ensures that our defenses remain strong against evolving security threats."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Proactive Risk Management"}
              />

              <InfoSection
                data-plasmic-name={"regulatoryCompliance"}
                data-plasmic-override={overrides.regulatoryCompliance}
                className={classNames(
                  "__wab_instance",
                  sty.regulatoryCompliance
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__ysH87
                      )}
                    >
                      {
                        "We align with stringent regulatory frameworks to meet or exceed data protection requirements:"
                      }
                    </p>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__j19FH)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__kzby
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__csCwy
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"SOC 2 Type II Certification:"}
                            </span>
                            <React.Fragment>
                              {
                                " Independent verification of our commitment to security, availability, and confidentiality."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__penpq
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__ngqHp
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"HIPAA Compliance:"}
                            </span>
                            <React.Fragment>
                              {
                                " Safeguarding Protected Health Information (PHI) for healthcare-focused clients."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi___4NtPz
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__i2Evz
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"GDPR and FERPA Compliance: "}
                            </span>
                            <React.Fragment>
                              {
                                "Transparent data usage and strict privacy controls for global and educational clients."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Regulatory Compliance"}
              />

              <InfoSection
                data-plasmic-name={"clientCentricSecurityFeatures"}
                data-plasmic-override={overrides.clientCentricSecurityFeatures}
                className={classNames(
                  "__wab_instance",
                  sty.clientCentricSecurityFeatures
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__qb6Bz
                      )}
                    >
                      {"We offer tools and practices to empower our users:"}
                    </p>
                    <RawUl
                      className={classNames(
                        "__wab_instance",
                        sty.rawUl___1WBeE
                      )}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__vgqgC
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__dFjz8
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Geofencing and MyQuickPass:"}
                            </span>
                            <React.Fragment>
                              {
                                " Ensure ACGME compliance and reduce manual errors in tracking work hours securely."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__eUtsq
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__l3TcL
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Procedure and Patient Logs: "}
                            </span>
                            <React.Fragment>
                              {
                                "Enable secure submission and tracking with centralized access to ensure oversight without compromising confidentiality."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__og4Wi
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__xJnGj
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Audit Trails:"}
                            </span>
                            <React.Fragment>
                              {
                                " Maintain transparency with comprehensive logs that track access and activity on the platform."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Client-Centric Security Features"}
              />

              <InfoSection
                data-plasmic-name={"trainingAndAwareness"}
                data-plasmic-override={overrides.trainingAndAwareness}
                className={classNames(
                  "__wab_instance",
                  sty.trainingAndAwareness
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__bf5L9
                      )}
                    >
                      {
                        "Security is a team effort. We continuously educate our staff and users:"
                      }
                    </p>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__lzEwi)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__sk78D
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__znYdo
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment> </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Employee Training:"}
                            </span>
                            <React.Fragment>
                              {
                                " All team members receive ongoing training in data protection and compliance best practices."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__zaeLo
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__mfzMy
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Client Resources:"}
                            </span>
                            <React.Fragment>
                              {
                                " Help documentation, webinars, and live training sessions ensure you know how to use MyEvaluations securely and effectively."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Training and Awareness"}
              />

              <InfoSection
                data-plasmic-name={"commitmentToContinuousImprovement"}
                data-plasmic-override={
                  overrides.commitmentToContinuousImprovement
                }
                className={classNames(
                  "__wab_instance",
                  sty.commitmentToContinuousImprovement
                )}
                content={
                  <React.Fragment>
                    <p
                      className={classNames(
                        "all",
                        "p",
                        "p__bvRZj",
                        "__wab_text",
                        sty.p__d64HE
                      )}
                    >
                      {
                        "Security is not a one-time task\u2014it\u2019s an ongoing priority:"
                      }
                    </p>
                    <RawUl
                      className={classNames("__wab_instance", sty.rawUl__qc28N)}
                    >
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__nlqi2
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__nhr3Y
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Regular Updates:"}
                            </span>
                            <React.Fragment>
                              {
                                " We implement regular software updates to address vulnerabilities and introduce new features."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                      <RawLi
                        className={classNames(
                          "__wab_instance",
                          sty.rawLi__yqRzX
                        )}
                      >
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__bvRZj",
                            "__wab_text",
                            sty.p__tz4BZ
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                              }
                              style={{ fontWeight: 700 }}
                            >
                              {"Client Feedback Integration:"}
                            </span>
                            <React.Fragment>
                              {
                                " We welcome feedback and continually enhance our security measures to meet your needs."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                      </RawLi>
                    </RawUl>
                  </React.Fragment>
                }
                heading={"Commitment to Continuous Improvement"}
              />

              <InfoSection
                data-plasmic-name={"questions"}
                data-plasmic-override={overrides.questions}
                className={classNames("__wab_instance", sty.questions)}
                content={
                  <p
                    className={classNames(
                      "all",
                      "p",
                      "p__bvRZj",
                      "__wab_text",
                      sty.p__ulLl3
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>
                        {
                          "Want to know more about our security practices? Our team is here to help!\nContact us at "
                        }
                      </React.Fragment>
                      {
                        <PlasmicLink__
                          data-plasmic-name={"link"}
                          data-plasmic-override={overrides.link}
                          className={classNames(
                            "all",
                            "a",
                            "a__bvRZj",
                            "__wab_text",
                            "plasmic_default__inline",
                            sty.link
                          )}
                          component={Link}
                          href={"mailto:support@myevaluations.com"}
                          legacyBehavior={false}
                          platform={"nextjs"}
                        >
                          {"support@myevaluations.com"}
                        </PlasmicLink__>
                      }
                      <React.Fragment>{" or call "}</React.Fragment>
                      <span
                        className={
                          "plasmic_default__all plasmic_default__span plasmic_default__span__bvRZj"
                        }
                        style={{ fontWeight: 700 }}
                      >
                        {"(866) 422-0554"}
                      </span>
                      <React.Fragment>
                        {" for personalized assistance."}
                      </React.Fragment>
                    </React.Fragment>
                  </p>
                }
                heading={"Questions?"}
              />
            </div>
          </div>
          {(
            hasVariant(globalVariants, "mobile", "mobile")
              ? false
              : hasVariant(globalVariants, "mobile", "tabletPortrait")
                ? true
                : true
          ) ? (
            <PlasmicImg__
              data-plasmic-name={"line"}
              data-plasmic-override={overrides.line}
              alt={""}
              className={classNames(sty.line)}
              displayHeight={"1067.99px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={
                hasVariant(globalVariants, "mobile", "tabletPortrait")
                  ? "895px"
                  : "auto"
              }
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/f8c2846a1d939511f6aa136587f7afe2.svg",
                fullWidth: 895,
                fullHeight: 1068,
                aspectRatio: 0.838015
              }}
            />
          ) : null}
        </div>
      </section>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  banner: [
    "banner",
    "container",
    "wrapper",
    "heading",
    "title",
    "contentRow",
    "contentColumn",
    "exploreOurSecurityPractices",
    "comprehensiveDataProtection",
    "h3",
    "proactiveRiskManagement",
    "regulatoryCompliance",
    "clientCentricSecurityFeatures",
    "trainingAndAwareness",
    "commitmentToContinuousImprovement",
    "questions",
    "link",
    "line"
  ],
  container: [
    "container",
    "wrapper",
    "heading",
    "title",
    "contentRow",
    "contentColumn",
    "exploreOurSecurityPractices",
    "comprehensiveDataProtection",
    "h3",
    "proactiveRiskManagement",
    "regulatoryCompliance",
    "clientCentricSecurityFeatures",
    "trainingAndAwareness",
    "commitmentToContinuousImprovement",
    "questions",
    "link",
    "line"
  ],
  wrapper: [
    "wrapper",
    "heading",
    "title",
    "contentRow",
    "contentColumn",
    "exploreOurSecurityPractices",
    "comprehensiveDataProtection",
    "h3",
    "proactiveRiskManagement",
    "regulatoryCompliance",
    "clientCentricSecurityFeatures",
    "trainingAndAwareness",
    "commitmentToContinuousImprovement",
    "questions",
    "link",
    "line"
  ],
  heading: ["heading", "title"],
  title: ["title"],
  contentRow: [
    "contentRow",
    "contentColumn",
    "exploreOurSecurityPractices",
    "comprehensiveDataProtection",
    "h3",
    "proactiveRiskManagement",
    "regulatoryCompliance",
    "clientCentricSecurityFeatures",
    "trainingAndAwareness",
    "commitmentToContinuousImprovement",
    "questions",
    "link"
  ],
  contentColumn: [
    "contentColumn",
    "exploreOurSecurityPractices",
    "comprehensiveDataProtection",
    "h3",
    "proactiveRiskManagement",
    "regulatoryCompliance",
    "clientCentricSecurityFeatures",
    "trainingAndAwareness",
    "commitmentToContinuousImprovement",
    "questions",
    "link"
  ],
  exploreOurSecurityPractices: ["exploreOurSecurityPractices"],
  comprehensiveDataProtection: ["comprehensiveDataProtection", "h3"],
  h3: ["h3"],
  proactiveRiskManagement: ["proactiveRiskManagement"],
  regulatoryCompliance: ["regulatoryCompliance"],
  clientCentricSecurityFeatures: ["clientCentricSecurityFeatures"],
  trainingAndAwareness: ["trainingAndAwareness"],
  commitmentToContinuousImprovement: ["commitmentToContinuousImprovement"],
  questions: ["questions", "link"],
  link: ["link"],
  line: ["line"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  banner: "div";
  container: "section";
  wrapper: "div";
  heading: "div";
  title: "h1";
  contentRow: "div";
  contentColumn: "div";
  exploreOurSecurityPractices: typeof InfoSection;
  comprehensiveDataProtection: typeof InfoSection;
  h3: "h3";
  proactiveRiskManagement: typeof InfoSection;
  regulatoryCompliance: typeof InfoSection;
  clientCentricSecurityFeatures: typeof InfoSection;
  trainingAndAwareness: typeof InfoSection;
  commitmentToContinuousImprovement: typeof InfoSection;
  questions: typeof InfoSection;
  link: "a";
  line: typeof PlasmicImg__;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSecurityPracticesBanner__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSecurityPracticesBanner__VariantsArgs;
    args?: PlasmicSecurityPracticesBanner__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSecurityPracticesBanner__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSecurityPracticesBanner__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSecurityPracticesBanner__ArgProps,
          internalVariantPropNames: PlasmicSecurityPracticesBanner__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSecurityPracticesBanner__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "banner") {
    func.displayName = "PlasmicSecurityPracticesBanner";
  } else {
    func.displayName = `PlasmicSecurityPracticesBanner.${nodeName}`;
  }
  return func;
}

export const PlasmicSecurityPracticesBanner = Object.assign(
  // Top-level PlasmicSecurityPracticesBanner renders the root element
  makeNodeComponent("banner"),
  {
    // Helper components rendering sub-elements
    container: makeNodeComponent("container"),
    wrapper: makeNodeComponent("wrapper"),
    heading: makeNodeComponent("heading"),
    title: makeNodeComponent("title"),
    contentRow: makeNodeComponent("contentRow"),
    contentColumn: makeNodeComponent("contentColumn"),
    exploreOurSecurityPractices: makeNodeComponent(
      "exploreOurSecurityPractices"
    ),
    comprehensiveDataProtection: makeNodeComponent(
      "comprehensiveDataProtection"
    ),
    h3: makeNodeComponent("h3"),
    proactiveRiskManagement: makeNodeComponent("proactiveRiskManagement"),
    regulatoryCompliance: makeNodeComponent("regulatoryCompliance"),
    clientCentricSecurityFeatures: makeNodeComponent(
      "clientCentricSecurityFeatures"
    ),
    trainingAndAwareness: makeNodeComponent("trainingAndAwareness"),
    commitmentToContinuousImprovement: makeNodeComponent(
      "commitmentToContinuousImprovement"
    ),
    questions: makeNodeComponent("questions"),
    link: makeNodeComponent("link"),
    line: makeNodeComponent("line"),

    // Metadata about props expected for PlasmicSecurityPracticesBanner
    internalVariantProps: PlasmicSecurityPracticesBanner__VariantProps,
    internalArgProps: PlasmicSecurityPracticesBanner__ArgProps
  }
);

export default PlasmicSecurityPracticesBanner;
/* prettier-ignore-end */
